import axios from 'axios';
import { BASE_TASK_STATUS } from '../components/constants';
import { authHeaders } from '../utils/authHeaders';


// Create a new task status
export const createTaskStatus = async (taskStatusData) => {
    try {
        const response = await axios.post(`${BASE_TASK_STATUS}/create`, taskStatusData, authHeaders());
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Get task statuses by history ID
export const getTaskStatusesByHistory = async (historyId) => {
    try {
        const response = await axios.get(`${BASE_TASK_STATUS}/${historyId}`, authHeaders());
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Update task status
export const updateTaskStatus = async (taskStatusData) => {
    try {
        const response = await axios.put(`${BASE_TASK_STATUS}/update`, taskStatusData, authHeaders());
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Update only the answer_status field (Akzeptiert / Weitere Prüfung / Information fehlt / Abgelehnt)
export const updateAnswerStatus = async ({ history_id, sq_id, answer_status }) => {
    try {
        const response = await axios.put(`${BASE_TASK_STATUS}/update-answer-status`, {
            history_id,
            sq_id,
            answer_status
        }, authHeaders());
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Delete task status
export const deleteTaskStatus = async (taskStatusData) => {
    try {
        const response = await axios.delete(`${BASE_TASK_STATUS}/delete`, {
            data: taskStatusData,
            ...authHeaders()
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};
